import { render, staticRenderFns } from "./order_by_id.vue?vue&type=template&id=b49edc64&scoped=true&"
import script from "./order_by_id.vue?vue&type=script&lang=js&"
export * from "./order_by_id.vue?vue&type=script&lang=js&"
import style0 from "./order_by_id.vue?vue&type=style&index=0&id=b49edc64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49edc64",
  null
  
)

export default component.exports